jQuery(initNavbarMenu)

function initNavbarMenu() {
  onToggle()
}

function onToggle() {
  const $navbarMenu = jQuery("#navbar")
  const $navbarToggle = jQuery('[data-collapse-toggle="navbar"]')
  const $links = jQuery("#navbar a")

  if ($navbarMenu.length === 0 || $links.length === 0 || $navbarToggle.length === 0) return

  $links.on("click", function () {
    if (!$navbarMenu.hasClass("hidden")) {
      $navbarToggle.trigger("click") // utilizza il toggle base di Flowbite
    }
  })
}
